import * as React from 'react';
import Tag from '../tag';
export default function PickerButton(props) {
    return <Tag color="blue" {...props}/>;
}
